import React, { useEffect, useState } from 'react';
import BookmarkIcon from 'components/Brand/Icons/Toolbox/BookmarkIcon';
import { WithUserContext } from 'utils/UserContext';
import { WithBookmarkContext } from 'utils/BookmarkContext';
import mapBookmarkData from 'utils/mapBookmarkData';
import toggleBookmark, { setPendingBookmark, getPendingBookmark } from './toggleBookmark';
import { BookmarkContainer } from './styles';

const ToolBoxBookmark = ({
  children,
  data,
  title,
  subTitle,
  label,
  type,
  subType,
  url,
  image,
  color = 'white',
  userInfo,
  setUserInfo,
  openLoginModal,
  onLogOut,
  ...props
}) => {
  const mappedData = mapBookmarkData({ subTitle, title, image, ...data }, type, url);
  const filled =
    mappedData && userInfo?.bookmarks?.filter((x) => x.url)?.some((x) => x.url === mappedData.url);
  const [isPending, setIsPending] = useState(false);

  useEffect(() => {
    const savedData = getPendingBookmark();
    if (userInfo && savedData) {
      toggleBookmark(savedData.filled, savedData.data, userInfo, setUserInfo, openLoginModal);
    }
  }, [userInfo]);

  const handleBookmarkIconClick = async (e) => {
    e.preventDefault();
    if (isPending) {
      return;
    }
    setIsPending(true);
    if (!userInfo) {
      if (openLoginModal) {
        setPendingBookmark(!filled, mappedData);
        setIsPending(false);
        openLoginModal();
      }
      return;
    }
    await toggleBookmark(!filled, mappedData, userInfo, setUserInfo, openLoginModal);
    setIsPending(false);
  };

  return (
    <BookmarkContainer
      className={` bookmark-container bookmark-container--${subType || mappedData.type}-type`}
      color={color}
      url={url}
      {...props}
    >
      {children}
      {mappedData?.url && (
        <div className="bookmark-icon" onClick={handleBookmarkIconClick}>
          <BookmarkIcon color={color} filled={filled} />
          {label && <div className="bookmark-label">{label}</div>}
        </div>
      )}
    </BookmarkContainer>
  );
};

export default WithBookmarkContext(WithUserContext(ToolBoxBookmark));
